(function() {
  const descriptionAccordion = document.querySelector('.disclosure__content.product-description');
  const productDimensions = document.getElementById('dimensionsTable');
  const selectorStyle = productDimensions ? productDimensions.dataset.selectorStyle : undefined;

  if (productDimensions) {
    setVariantWeight(productDimensions);
  }

  if (descriptionAccordion) {
    const targetDropdown = document.querySelector('.disclosure__content.product-description').firstElementChild;
    if (targetDropdown) targetDropdown.classList.add('active');
    handleDescriptionAccordion(descriptionAccordion);
  }
  
  document.addEventListener('on:variant:change', () => {
    if (productDimensions) {
      setVariantWeight(productDimensions);
    }
    if (descriptionAccordion) {
      handleDescriptionAccordion(descriptionAccordion);
    }
  });

  // Switches between different product descriptions based on the sku value
  function handleDescriptionAccordion(accordion) {
    let targetSku = document.querySelector('.product-sku__value').innerText;
    targetSku = targetSku.replace('-PERS', '');
    if (accordion.querySelector(`#${targetSku}`)) {
      const activeDescription = accordion.querySelector('.active');
      if (activeDescription) activeDescription.classList.remove('active');
      accordion.querySelector(`#${targetSku}`).classList.add('active');
    }
  }

  // Set the weight, width and height values on the product dimensions table based on active variant
  function setVariantWeight(table) {
    // Get the active value from the custom-select dropdown menu
    let weight = '';
    if (selectorStyle === "buttons") {
      weight = document.querySelector('.option-selector input:checked').value;
    } else {
      weight = document.querySelector("variant-picker .custom-select__option[aria-selected='true']").dataset.value;
    }

    if (weight === '' || !weight.includes('g')) return;

    const tableWidth = table.querySelector('#variantWidth');
    const tableLength = table.querySelector('#variantLength');
    const tableWeight = table.querySelector('#variantWeight');

    tableWidth.dataset.variantWidth.split(',').forEach(width => {
      if (width.includes(weight)) {
        tableWidth.innerHTML = `${width.split('-')[0]}mm`;
      }
    });

    tableLength.dataset.variantLength.split(',').forEach(length => {
      if (length.includes(weight)) {
        tableLength.innerHTML = `${length.split('-')[0]}mm`;
      }
    });

    tableWeight.innerHTML = weight;
  }
}());